/** @deprecated Initializes empty data. */
const initLocationObject = () => ({
  lat: 0,
  lng: 0,
  addressComponents: [],
  formattedAddress: '',
  aptNumber: '',
  additionalInstructions: ''
});

export { initLocationObject };
